import React from 'react';
import { ProcessDefinition } from '../../types/processDefinition';
import './ProcessNavigationPanel.css';

interface ProcessNavigationPanelProps {
  process: ProcessDefinition;
  onNavigateToProcess: (processId: string) => void;
}

export const ProcessNavigationPanel: React.FC<ProcessNavigationPanelProps> = ({
  process,
  onNavigateToProcess,
}) => {
  // This is a simplified implementation
  // In a real implementation, you would load related processes based on shared artifacts/states

  const relatedProcesses = [
    // Mock data - in reality this would come from the API
    {
      id: 'process-1',
      name: 'Related Process 1',
      description: 'A process that shares artifacts with this one',
      sharedArtifacts: 2,
    },
    {
      id: 'process-2',
      name: 'Related Process 2',
      description: 'Another related process',
      sharedArtifacts: 1,
    },
  ];

  return (
    <div className="process-navigation-panel">
      <div className="navigation-header">
        <h3>Process Navigation</h3>
      </div>

      <div className="current-process">
        <h4>Current Process</h4>
        <div className="process-info">
          <div className="process-name">{process.name}</div>
          <div className="process-id">ID: {process.id}</div>
        </div>
      </div>

      <div className="related-processes">
        <h4>Related Processes</h4>
        {relatedProcesses.length === 0 ? (
          <p className="no-related">No related processes found.</p>
        ) : (
          <ul className="related-processes-list">
            {relatedProcesses.map((relatedProcess) => (
              <li key={relatedProcess.id} className="related-process-item">
                <button
                  onClick={() => onNavigateToProcess(relatedProcess.id)}
                  className="related-process-link"
                >
                  <div className="related-process-name">{relatedProcess.name}</div>
                  <div className="related-process-description">{relatedProcess.description}</div>
                  <div className="shared-artifacts">
                    {relatedProcess.sharedArtifacts} shared artifact
                    {relatedProcess.sharedArtifacts !== 1 ? 's' : ''}
                  </div>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="navigation-tips">
        <h4>Navigation Tips</h4>
        <ul className="tips-list">
          <li>Click on state navigation buttons (🔗) to see processes using that state</li>
          <li>Use the related processes to explore connected workflows</li>
          <li>Processes are related when they share artifacts or states</li>
        </ul>
      </div>
    </div>
  );
};
